export default class NavigationHistory {
  public static get lastNavigationType():
    | "back_forward"
    | "navigate"
    | "prerender"
    | "reload" {
    // This method is only available for 2018+ browsers
    if (window.performance) {
      const entries = performance.getEntriesByType("navigation");
      const lastEntry = entries[0] as PerformanceNavigationTiming;
      if (lastEntry) {
        return lastEntry.type;
      }
    }

    // This returns the legacy navigation type
    switch (performance.navigation.type) {
      case performance.navigation.TYPE_RELOAD: {
        return "reload";
      }
      case performance.navigation.TYPE_NAVIGATE: {
        return "navigate";
      }
      case performance.navigation.TYPE_RESERVED: {
        return "prerender";
      }
      case performance.navigation.TYPE_BACK_FORWARD:
      default: {
        return "back_forward";
      }
    }
  }

  public static RefreshOnHistoryBack(): void {
    window.addEventListener("pageshow", (event) => {
      const historyTraversal =
        //If loading from cache
        event.persisted ||
        //Or navigated to via the history
        NavigationHistory.lastNavigationType === "back_forward";
      if (historyTraversal) {
        // Handle page restore.
        window.location.reload();
      }
    });
  }
}
